import type { IAppEvent } from '~/types/event'
import type { IGetSeriesDataBody } from '~/types/graph-builder'

export interface ViewProps {
  analyticsApiFn?: (body: IGetSeriesDataBody[]) => Promise<any>
  eventsData?: IAppEvent[]
  isAppLoading: boolean
  kpiField: string
}

export const viewClassName = 'cohorted-analytics-view'
